import Authenticate from './Authenticate.container';

export default Authenticate;
